import React from 'react';
import { SectionWrapper } from '../../components';
import ListItem from '../../components/ListItem/ListItem';
import { SECTION } from '../../constants/sections';
import { Theme } from '../../constants/styles';
import aws from '../../assets/images/aws.png';

const Awards = () => {
  return (
    <SectionWrapper section={SECTION.awards} theme={Theme.Dark}>
      <div className="list">
        <ListItem
          image={aws}
          href="https://cp.certmetrics.com/amazon/en/public/verify/credential/ND2GFZD281RQ1BKT"
          alt="AWS Certified Solutions Architect - Associate"
          title="AWS"
          description="Certified Solutions Architect - Associate"
        />
      </div>
    </SectionWrapper>
  );
};

export default Awards;
